import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { IconComponent } from "../../helper/icon/icon.component";

@Component({
  selector: 'app-connect-vrchat-success',
  imports: [MatDialogModule, MatButtonModule, IconComponent],
  templateUrl: './connect-vrchat-success.component.html',
  styleUrl: './connect-vrchat-success.component.less'
})
export class ConnectVrchatSuccessComponent {

}
